import { createUseStyles } from "react-jss";

type TStyleProps = {
  color?: string;
  size?: number;
};

const getSize = ({ size }: TStyleProps) => {
  return size ? `${size}px` : "1em";
};

export const useStyles = createUseStyles({
  ":has($icon)": {
    fontSize: "var(--icon-medium-size)",
  },
  "icon": {
    "color": ({ color }: TStyleProps) => color || "currentColor",
    "fill": "currentColor",
    "height": "1em",
    "width": "1em",
    "minWidth": "1em",
    "display": "inline-flex",
    "verticalAlign": "text-top",
    "& > svg": {
      height: "100%",
      width: "100%",
    },
    "&$customSize": {
      height: getSize,
      width: getSize,
      fontSize: getSize,
    },
    "&$small": {
      fontSize: "var(--icon-small-size)",
    },
    "&$medium": {
      fontSize: "var(--icon-medium-size)",
    },
    "&$large": {
      fontSize: "var(--icon-large-size)",
    },
    "&$xl": {
      fontSize: "var(--icon-xl-size)",
    },
    "&$border": {
      borderRadius: "var(--radius)",
      border: "1px solid var(--border)",
    },
    "&$clickable:not($disabled)": {
      "cursor": "pointer",
      "transition": "opacity 0.1s, transform 0.1s",

      "&:hover": {
        opacity: 0.6,
        transform: "scale(1.1)",
      },
    },
    "&$disabled": {
      pointerEvents: "none",
      color: "var(--muted)",
    },
  },
  "small": {},
  "medium": {},
  "large": {},
  "xl": {},
  "customSize": {},
  "border": {},
  "clickable": {},
  "disabled": {},
});
